let wishlistModalListenersInitialized = false;
let swymAddToWishlist = null;
let swymCallbackRegistered = false;

const bindWishlistNotification = (swym, expectedProductId, expectedVariantId) => {
  if (
    !swym ||
    !swym.evtLayer ||
    !swym.JSEvents ||
    !swym.JSEvents.addedToWishlist ||
    !swym.ui ||
    typeof swym.ui.showSuccessNotification !== 'function'
  ) {
    return () => { };
  }

  const handler = (data) => {
    const eventProductId = parseInt(data?.detail?.d?.empi, 10);
    const eventVariantId = parseInt(data?.detail?.d?.epi, 10);

    if (!Number.isNaN(eventProductId) && eventProductId !== expectedProductId) {
      return;
    }

    if (!Number.isNaN(eventVariantId) && eventVariantId !== expectedVariantId) {
      return;
    }
    console.log('data', data);
    const productTitle = data?.detail?.d?.dt.replace(' - ASTR the Label', '') || 'Item';
    const productImage = data?.detail?.d?.iu || '';
    const productVariantTitle = data?.detail?.d?.vi || '';
    const successMessage = `
      <div style="display: flex; align-items: center;">
        <img src="${productImage}" alt="${productTitle}" style="width: 50px; height: auto; object-fit: cover; margin-right: 10px; vertical-align: middle;" />
        <div>
          <strong>${productTitle}</strong>${productVariantTitle ? `<span> - ${productVariantTitle}</span>` : ''}
          <p>has been added to your wishlist!</p>
          <a href="/pages/wishlist" style="text-decoration: underline;">View Wishlist</a>
        </div>
      </div>
    `;
    swym.ui.showSuccessNotification({ message: successMessage });
    swym.evtLayer.removeEventListener(swym.JSEvents.addedToWishlist, handler);
  };

  swym.evtLayer.addEventListener(swym.JSEvents.addedToWishlist, handler);

  return () => {
    swym.evtLayer.removeEventListener(swym.JSEvents.addedToWishlist, handler);
  };
};

const swymCallbackFn = (_swat) => {
  if (_swat && typeof _swat.addToWishList === 'function') {
    swymAddToWishlist = _swat.addToWishList.bind(_swat);
  }
};

/** Add/Remove product to/from the wishlist using the wishlist modal **/
export default () => {
  if (wishlistModalListenersInitialized) {
    if (!swymAddToWishlist && window._swat && typeof window._swat.addToWishList === 'function') {
      swymAddToWishlist = window._swat.addToWishList.bind(window._swat);
    }

    if (!swymCallbackRegistered) {
      // Ensure Swym is loaded before triggering the API.
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push(swymCallbackFn);
      swymCallbackRegistered = true;
    }

    return;
  }

  if (window._swat && typeof window._swat.addToWishList === 'function') {
    swymAddToWishlist = window._swat.addToWishList.bind(window._swat);
  }

  // Ensure Swym is loaded before triggering the API.
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(swymCallbackFn);
  swymCallbackRegistered = true;

  const handleWishlistModalAction = (e, source = 'click') => {
    const wishlistButton =
      e.target.closest('#quicklook-modal[data-quickview-type="wishlist"] [data-quickview-add-to-wishlist]') ||
      e.target.closest('#quicklook-modal-mobile[data-quickview-type="wishlist"] [data-quickview-add-to-wishlist]');

    if (!wishlistButton) {
      return;
    }

    // On mobile tap, ignore the follow-up synthetic click.
    if (source === 'click') {
      const lastTouchTs = Number(wishlistButton.dataset.lastTouchTs || 0);
      if (lastTouchTs && Date.now() - lastTouchTs < 700) {
        return;
      }
    }

    if (source === 'touchend') {
      wishlistButton.dataset.lastTouchTs = String(Date.now());
    }

    e.preventDefault();

    if (wishlistButton.hasAttribute('disabled')) {
      return;
    }

    // If no sizes selected, add the active class to data-product-option-sizes-error
    const modal = wishlistButton.closest('#quicklook-modal[data-quickview-type="wishlist"], #quicklook-modal-mobile[data-quickview-type="wishlist"]');
    const sizeError = modal ? modal.querySelector('[data-product-option-sizes-error]') : null;
    const activeSizes = modal ? modal.querySelectorAll('[data-quickview-product-option-size].active') : 0;
    const is_mobile = modal && modal.id === 'quicklook-modal-mobile';

    if (sizeError && activeSizes?.length === 0) {
      const errorMessage = 'Please select a size before adding to the wishlist.';
      sizeError.textContent = errorMessage;
      sizeError.classList.add('active');
      return;
    }

    const productGrid = modal ?
      is_mobile ? modal.querySelector('[data-quickview-mobile-content]') : modal.querySelector('[data-product-grid-content]')
      : null;
    const variantSelect = modal ? modal.querySelector('[data-quickview-product-select]') : null;

    const productId = parseInt(productGrid?.dataset?.productId, 10);
    const variantId = parseInt(variantSelect?.value, 10);

    if (Number.isNaN(productId) || Number.isNaN(variantId)) {
      console.error('[wishlist modal] Product ID or Variant ID is missing.');
      return;
    }

    const wishlistButtonTiles = document.querySelectorAll(`[data-product-tile][data-product-id="${productId}"]`);

    if (wishlistButton.getAttribute('name') === 'add') {
      const addToWishList = swymAddToWishlist || (window._swat && typeof window._swat.addToWishList === 'function' ? window._swat.addToWishList.bind(window._swat) : null);

      if (!addToWishList) {
        console.error('[wishlist modal] Swym addToWishList is not available.');
        return;
      }

      const clearNotificationListener = bindWishlistNotification(window._swat, productId, variantId);

      wishlistButton.setAttribute('disabled', 'true');

      const productPayload = {
        empi: productId,
        epi: variantId,
        du: window.location.origin,
        et: 4,
        product: {
          source: 'quick'
        }
      };

      addToWishList(productPayload, () => {
        wishlistButton.innerHTML = window.theme.strings.savedToWishlist;

        // Update the saved list of wishlist products in the global window object
        window.wishlist_products = window.wishlist_products || [];
        window.wishlist_products.push(productPayload);

        // Update the wishlist icons in product tiles
        for (const wishlistButtonTile of wishlistButtonTiles) {
          wishlistButtonTile.querySelector('[data-product-wishlist]')?.classList.add('active');
        }

        // Safety cleanup in case Swym event payload shape changes and never matches.
        window.setTimeout(() => {
          // Also change button to "Remove from wishlist" after 3 seconds if the same size is still selected.
          // See quicklook/product-options.js selectSizeQuicklook()
          if (wishlistButton.hasAttribute('disabled')) {
            wishlistButton.setAttribute('name', 'remove');
            wishlistButton.setAttribute('aria-label', window.theme.strings.removeFromWishlist);
            wishlistButton.setAttribute('title', window.theme.strings.removeFromWishlist);
            wishlistButton.classList.remove('btn--primary');
            wishlistButton.classList.add('btn--secondary');
            wishlistButton.textContent = window.theme.strings.removeFromWishlist;
            wishlistButton.removeAttribute('disabled');
          }

          clearNotificationListener();
        }, 3000);
      });

      return;
    }

    if (wishlistButton.getAttribute('name') === 'remove') {
      const removeFromWishList = window._swat && typeof window._swat.removeFromWishList === 'function' ? window._swat.removeFromWishList.bind(window._swat) : null;

      if (!removeFromWishList) {
        console.error('[wishlist modal] Swym removeFromWishList is not available.');
        return;
      }

      wishlistButton.setAttribute('disabled', 'true');

      const productPayload = {
        empi: productId,
        epi: variantId,
        du: window.location.origin,
      };

      removeFromWishList(productPayload, () => {
        wishlistButton.innerHTML = window.theme.strings.addToWishlist;

        // Update the saved list of wishlist products in the global window object
        window.wishlist_products = window.wishlist_products || [];
        window.wishlist_products = window.wishlist_products.filter(item => !(item.empi === productId && item.epi === variantId));

        // Update the wishlist icons in product tiles only if no other wishlist items exist for the same product
        const hasOtherWishlistItems = window.wishlist_products.some(item => item.empi === productId);
        if (!hasOtherWishlistItems) {
          for (const wishlistButtonTile of wishlistButtonTiles) {
            wishlistButtonTile.querySelector('[data-product-wishlist]')?.classList.remove('active');
          }
        }

        // Also change button to "Add to wishlist" after 4 seconds
        // window.setTimeout(() => {
        wishlistButton.setAttribute('name', 'add');
        wishlistButton.setAttribute('aria-label', window.theme.strings.addToWishlist);
        wishlistButton.setAttribute('title', window.theme.strings.addToWishlist);
        wishlistButton.classList.add('btn--primary');
        wishlistButton.classList.remove('btn--secondary');
        wishlistButton.textContent = window.theme.strings.addToWishlist;
        wishlistButton.removeAttribute('disabled');
        // }, 3000);
      });
    }
  };

  document.addEventListener('click', (e) => {
    handleWishlistModalAction(e, 'click');
  });

  document.addEventListener('touchend', (e) => {
    handleWishlistModalAction(e, 'touchend');
  });

  wishlistModalListenersInitialized = true;
};
